import { render, staticRenderFns } from "./ChatRight.vue?vue&type=template&id=b9664d3c&scoped=true&"
import script from "./ChatRight.vue?vue&type=script&lang=js&"
export * from "./ChatRight.vue?vue&type=script&lang=js&"
import style1 from "./ChatRight.vue?vue&type=style&index=1&id=b9664d3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9664d3c",
  null
  
)

export default component.exports